import React from 'react';
import { ExplorerContextProvider, useExplorerContext } from '../../../../services/context/ExplorerContext';
import { PortfolioHeader } from '../../components';
import { DashboardHeader } from '../Dashboard/scenes/PortfolioDashboard/components/DashboardHeader';
import { StructureWheel } from './components/StructureWheel';
import { AllocationBreakdown } from './components/AllocationBreakdown/AllocationBreakdown';
import { Grid, Row, Col, Modal } from 'rsuite';
import { TopPositionBreakdown } from './components/TopPositionBreakdown/TopPositionBreakdown';
import s from './PortfolioExplorer.module.scss';
import { ExpandButton } from '../../../../components/UIWidgets/ExpandButton';
import PortfolioUpcomingEvents from '../../components/PortfolioUpcomingEvents/PortfolioUpcomingEvents';
import { useSafariHack } from '../../../../services/hooks/useSafariHack';

const components = new Map();
components.set('StructureWheel', { Comp: StructureWheel, colWidth: 24, label: 'Structure pie chart' });

components.set('TopPositionBreakdown', { Comp: TopPositionBreakdown, colWidth: 12, label: 'Top position breakdown' });
components.set('AllocationBreakdown', { Comp: AllocationBreakdown, colWidth: 12, label: 'Allocation breakdown' });

export const PortfolioExplorerInner = () => {
  const [expandedItem, setExpandedItem] = React.useState<string | undefined>();
  const { selectedPosition, setSelectedPosition } = useExplorerContext();
  const { flex } = useSafariHack();

  const renderModalContent = React.useMemo(() => {
    const component = !!expandedItem ? components.get(expandedItem) : undefined;
    if (!component) {
      return null;
    }
    const { Comp } = component;
    return (
      <div>
        <Modal.Header>
          <Modal.Title classPrefix={s.modalTitle}>{component.label}</Modal.Title>
        </Modal.Header>
        <div style={{ height: 20 }} />
        <Comp height={800} expanded={true} />
      </div>
    );
  }, [expandedItem]);

  const closeModal = () => setExpandedItem(undefined);

  return (
    <div>
      <PortfolioHeader showDashboardMenu={false} />
      <DashboardHeader page={'Explorer'} hideCustodianFilter={true} />
      <div style={{ display: flex }}>
        <div style={{ flex: 1, marginRight: '0.25rem' }}>
          <Grid fluid={true}>
            <Row>
              {[...components].map(([key, value]) => {
                const { colWidth, Comp, updateLabel } = value;

                return (
                  <Col key={key} xs={24} lg={colWidth} style={{ marginBottom: 10 }}>
                    <div style={{ position: 'relative' }}>
                      <Comp updateLabel={updateLabel?.bind(value)} />
                      <ExpandButton onClick={() => setExpandedItem(key)} />
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Grid>
        </div>
        <div style={{ height: '100%', overflow: 'hidden' }}>
          <PortfolioUpcomingEvents
            // setExpandedItem={setExpandedItem}
            deselectPosition={() => setSelectedPosition(null)}
            selectedPosition={selectedPosition}
          />
        </div>
      </div>
      <Modal full={true} show={!!expandedItem} onHide={closeModal} className={s.modalContainer}>
        {renderModalContent}
      </Modal>
    </div>
  );
};

export const PortfolioExplorer = () => {
  return (
    <ExplorerContextProvider>
      <PortfolioExplorerInner />
    </ExplorerContextProvider>
  );
};
